import clsx from "clsx";
import {Button as MuiButton, ButtonProps as MuiButtonProps, LinearProgress} from "@mui/material";
import React, {forwardRef, ReactNode} from "react";
import styles from "./Button.module.css";
import Keys from "../../constants/helper";

interface ButtonProps extends MuiButtonProps {
    className?: string;
    fullWidth?: boolean;
    startIcon?: ReactNode;
    isLoading?: boolean;
    children: ReactNode;
    progress?: number;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>((
    {
        className,
        isLoading,
        fullWidth,
        startIcon,
        children,
        progress,
        ...restAttributes
    }, ref) => {
    const role = localStorage.getItem(Keys.EPIC_USER_ROLE);

    const classes = clsx(className);

    return (
        <MuiButton
            fullWidth={fullWidth}
            ref={ref}
            startIcon={!isLoading && startIcon}
            className={classes}
            {...restAttributes}
            disabled={isLoading || restAttributes.disabled}
            sx={{
                position: "relative",
                overflow: "hidden",
                ...restAttributes.sx,
            }}
        >
            {isLoading
                ? <div className={clsx(styles.loader, role === "KIDS" && styles.loaderKids)}></div>
                : children}
            {progress !== undefined && progress > 0 && (
                <LinearProgress
                    variant="determinate"
                    value={progress}
                    sx={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        height: 5,
                        backgroundColor: "rgba(255,255,255,0.2)",
                        "& .MuiLinearProgress-bar": {
                            backgroundColor: "red",
                        },
                    }}
                />
            )}
        </MuiButton>
    );
});

export default Button;
